import { SECTION_MARGIN } from "../../config/constants";
import { useResponsive } from "../../hooks";
import StackComponent from "../Base/StackComponent";
import TypographyComponent from "../Base/TypographyComponent";

const BasicPublicScreenWithHeading = ({ heading, children, withMargin }) => {
  const { isMediumScreen, isSmallScreen, isExtraSmallScreen } = useResponsive();
  const PADDING_X = isExtraSmallScreen ? "40px" : SECTION_MARGIN;
  return (
    <>
      <StackComponent
        direction="column"
        sx={{ p: `0 ${withMargin ? PADDING_X : "0"}`, mt: "30px" }}
        spacing="50px"
      >
        <TypographyComponent
          sx={{ textAlign: "center" }}
          variant="landingPagePaymentMethods"
          component="h1"
        >
          {heading}
        </TypographyComponent>
        <section>{children}</section>
      </StackComponent>
    </>
  );
};

BasicPublicScreenWithHeading.defaultProps = {
  withMargin: true,
};

export default BasicPublicScreenWithHeading;
